<template>
    <form @submit.prevent="submit" :class="{ submitting: submitted }">
        <img class="img-fluid mb-4 w-75" :src="defaultLogoUrl" :alt="defaultCompanyAlias" srcset="">
        <p class="h3 mb-3">{{ i18n('Two-Step Activation') }}</p>
        <div class="text-center alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row g-2 mb-2">
            <div class="col-12 text-center mb-3">
                <p>{{ autentication.message }}</p>
            </div>
            <div class="col-12 text-center mb-3" v-if="autentication.qr_code">
                <img :src="autentication.qr_code" alt="" width="200" height="200" class="mb-2">
            </div>
            <div class="col-12 text-center mb-3" v-if="autentication.secret_key">
                <p class="mb-0">{{ i18n('Or enter the code below:') }}</p>
                <h5>{{ autentication.secret_key }}</h5>
            </div>
        </div>
        <div class="d-grid mb-3 mt-4">
            <button type="submit" class="btn btn-dark btn-dark-petrol" :disabled="submitted">
                <span v-if="submitted" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden"> {{ i18n('Sending ...') }}</span>
                </span>
                {{ i18n('Activate') }}
            </button>
        </div>
    </form>
</template>
<script>

import api from "@/api.js";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";
import $env from "@/tools/environment.js";
const defaultLogoUrl = $env('VITE_DEFAULT_LOGO_URL');
const defaultCompanyAlias = $env('VITE_DEFAULT_COMPANY_ALIAS');
const loginImagePath = $env('VITE_DEFAULT_LOGIN_IMAGE');

export default {
    components: {
        Field,
    },
    data() {
        return {
            errorMessage: null,
            loginImagePath,
            defaultLogoUrl,
            submitted: false,
            defaultCompanyAlias,
            autentication: {},
        };
    },
    emits: ['autenticated'],
    props: {
        username: {
            type: String,
            default: null,
        },
        password: {
            type: String,
            default: null,
        },
    },
    created() {
        api.post('login/ad/2fa/qr2FA', { 'username': this.username, 'password': this.password })
            .then((response) => {
                this.autentication = response;
            }).catch((error) => {
                this.errorMessage = translatedErrorMessage(error);
            });
    },
    methods: {
        submit() { 
            api.post('login/ad/2fa/enable', { 'username': this.username, 'password': this.password })
            .then(() => {
                this.$emit('autenticated');
            }).catch((error) => {
                this.errorMessage = translatedErrorMessage(error);
            });
        },
    },
}

</script>

<style lang="scss" scoped>
form {
    max-width: 320px;
}
</style>
